import { render, staticRenderFns } from "./a-list.vue?vue&type=template&id=94976c80&"
import script from "./a-list.vue?vue&type=script&lang=ts&"
export * from "./a-list.vue?vue&type=script&lang=ts&"
import style0 from "./a-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports